import { QueryHookOptions, useQuery } from '@apollo/client';

import operation from './currentUserManagedTeamsQuery.graphql';

export const useCurrentUserManagedTeamsQuery = (
  opts?: QueryHookOptions<
    CurrentUserManagedTeamsQuery,
    CurrentUserManagedTeamsQueryVariables
  >,
) =>
  useQuery<CurrentUserManagedTeamsQuery, CurrentUserManagedTeamsQueryVariables>(
    operation,
    opts,
  );
